import { t } from './helpers/i18n';

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
global.t = t;
